import React from "react";

import Link from "../../Link";

export default function CardLink({
  id,
  url,
  children,
  trackingProperties = {},
  ...linkProps
}: $TSFixMe) {
  return (
    <Link
      to={url}
      trackingName="parent dashboard card"
      trackingUniqueId={id}
      sharedProperties={trackingProperties}
      useLinkTracking
      {...linkProps}
      trackViews={true}
    >
      {children}
    </Link>
  );
}
